import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/cut-team-management',
      name: 'admin-cut-team-management',
      component: () => import(/* webpackChunkName: "page-admin-plain-order-management-cut-team-management" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "切位团期管理"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "订单管理"
                                        },
                                        {
                                                  name: "切位团期管理"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
